import { Article } from '../../../types/DataTypes'
import { capitalizeFirstLetter } from '../../../utils'
import makeShortSizeCode from '../../../utils/makeShortSizeCode'

export const makeArticleDescription = (article: Article): string => {
  const { collectionCode = '', sizeCode = '', modelCode = '', baseColorCode = '', secondColorCode = '' } = article

  const getNonNAValue = (value: string) => {
    if (value === 'N/A') return ''
    return value
  }

  return [
    capitalizeFirstLetter(getNonNAValue(collectionCode).toLowerCase()),
    makeShortSizeCode(getNonNAValue(sizeCode)),
    capitalizeFirstLetter(getNonNAValue(modelCode).toLowerCase()),
    getNonNAValue(baseColorCode)
      .split('_')
      .map(colorWord => colorWord.charAt(0))
      .join(''),
    capitalizeFirstLetter(getNonNAValue(secondColorCode).toLowerCase()),
  ]
    .filter(val => !!val)
    .join(' ')
}

export const listHasOnlyUniqueStrings = (list: string[]) => new Set(list).size === list.length
